import React from "react";
import { Props } from "./types";

function ColorTextIcon({ className, color = "currentColor" }: Props) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      width="16"
      height="16"
    >
      <path
        d="M4 20 L12 4 L20 20"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="7"
        y1="14"
        x2="17"
        y2="14"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <rect x="2" y="21.5" width="20" height="2.5" rx="1.2" fill={color} />
    </svg>
  );
}

export { ColorTextIcon };
